import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { OntologyFormType } from '@gnv-shared/types';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ContentType, TableColumn, TableColumnAction } from 'daisy-design-system-front';
import { DialogService } from '../../../../services/dialog.service';
import { StationGnv } from '../../../../../../swagger-gen/gnvert-secured/models/station-gnv';

@Injectable({
  providedIn: 'root'
})
export class StationTagsConfiguration {

  private _valueFormGroup!: FormGroup<OntologyFormType>;

  public set valueFormGroup(value: FormGroup<OntologyFormType>) {
    this._valueFormGroup = value;
  }

  constructor(
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly store: Store,
    private readonly translate: TranslateService
  ) {
  }

  public getTableColumns(): TableColumn[] {
    return [
      { label: this.translate.instant('export-template.table.columns.name'), fieldName: "name", sortable: false, contentType: ContentType.TEXT , fieldId: columnIds.NAME },
      { label: this.translate.instant('export-template.table.columns.code'), fieldName: "code", sortable: false, contentType: ContentType.TEXT , fieldId: columnIds.NAME },
      {
        label: this.translate.instant('export-template.table.columns.actions'),
        fieldName: 'actions',
        ColumnType: 'action',
        actions: this.getImplementedTableRowsActions(),
        contentType: ContentType.UNKNOWN,
        fieldId: undefined
      }
    ];
  }

  private getImplementedTableRowsActions(): Array<TableColumnAction> {
    return [
      {
        label: '',
        iconStyleClass: 'fa-solid fa-pen',
        tooltip: this.translate.instant('export-creation.table.rowActions.setting'),
        callbackFunc: (row: StationGnv) => {
          this.dialogService.openTagsView({stationUid: row.uid, stationName: row.name, valueFormGroup: this._valueFormGroup});
        },
      },
    ]
  }

}

enum columnIds {
  NAME = 'NAME',
}
